import React from 'react';
import {
  ScrollView,
  StyleSheet,
  Text,
  View,
} from './components/base_components';

import PrizeButton from './components/buttons/prize_button';
import PrizeOverlay from './components/overlays/prize_overlay';
import MenuButton from './components/buttons/menu_button';
import DankCoinDisplay from './components/dank_coin_display';
import { PRIZE_LIST, Prize } from './data/prizes';

const styles = StyleSheet.create({
  prizeListScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
  },
  scrollInner: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    jusityfContent: 'flex-start',
    alignItems: 'center',
    overflowY: 'scroll',
  },
  titleWrapper: {
    marginTop: '6em',
    marginLeft: '2em',
    marginRight: '2em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleText: {
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  dankCoin: {
    position: 'absolute',
    top: '1em',
    right: '1em',
  },
  prizeList: {
    marginTop: '2em',
    marginBottom: '5em',
    width: '25em',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  prizeButton: {
    marginTop: '1em',
    marginBottom: '2em',
  },
});

type Props = {};
type State = {
  show_prize: Prize | null;
};

export default class PrizeListScreen extends React.PureComponent<Props, State> {
  state = {
    show_prize: null,
  };
  _onPrizePress = show_prize => this.setState({ show_prize });
  _onPrizeDone = () => this.setState({ show_prize: null });

  render() {
    const { show_prize } = this.state;
    let overlay = null;
    if (show_prize) {
      overlay = <PrizeOverlay prize={show_prize} onDone={this._onPrizeDone} />;
    }

    const prizes = PRIZE_LIST.map(prize => {
      return (
        <PrizeButton
          key={prize.prize_id}
          style={styles.prizeButton}
          prize={prize}
          onPress={this._onPrizePress}
        />
      );
    });

    return (
      <View style={styles.prizeListScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <DankCoinDisplay style={styles.dankCoin} />
          <View style={styles.titleWrapper}>
            <Text style={styles.titleText}>Dank Coin Prizes:</Text>
          </View>
          <View style={styles.prizeList}>{prizes}</View>
        </ScrollView>
        <MenuButton />
        {overlay}
      </View>
    );
  }
}
